var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_321_1",
    "data-name": "Component 321 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.976,
    height: 15.313,
    viewBox: "0 0 30.976 15.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64106",
    "data-name": "Path 64106",
    d: "M1003.381,2185.172a20.29,20.29,0,0,0-21.786,0,4.486,4.486,0,1,0,0,8.969,20.294,20.294,0,0,0,21.786,0,4.486,4.486,0,1,0,0-8.969Zm-16.632,4.484a5.748,5.748,0,1,1,1.683,4.055A5.712,5.712,0,0,1,986.749,2189.656Z",
    transform: "translate(-977 -2182)",
    fill: "#191bc3",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64107",
    "data-name": "Path 64107",
    d: "M2886.239,2883.12a3.128,3.128,0,1,0-.916,2.2A3.084,3.084,0,0,0,2886.239,2883.12Z",
    transform: "translate(-2867.631 -2875.463)",
    fill: "#191bc3",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/blue-eye.e86e8efe8921354946d1386d1ce5d0ba.svg";
export { ForwardRef as ReactComponent };